import combinedActions from '../redux/actions/combinedActions'
import {lobbySetLoader, setActivePage} from "../redux/actions/lobby/actions";
class UserSockets {
    constructor() {
        this.socket = null;
    }
    onConnect(socket) {
        this.socket = socket;
        console.log('client connected');
    }
    disconnectSocket(err) {
        this.socket = null;
        console.log('client disconnected', err);
    }

    onConnectionError(dispatch, error = 'connection_error') {
        this.socket = null;
        dispatch(lobbySetLoader({err: error}))
        dispatch(setActivePage({activePage: 'Cash'}))
        console.log('connection error', error);
    }
    handleGameSocketEvents(data, dispatch) {
        const {action, payload, isDispatch} = data;
         if(isDispatch) {
             const method = combinedActions[action];
             if (method) {
                 dispatch(method(payload));
             }
             if (action === 'roomEnter') {
                 dispatch(combinedActions['selectActiveRoomTab']({roomId: payload.roomId}))
             }
             if (action === 'exitRoom') {
                 dispatch(combinedActions['selectActiveRoomTab']({roomId: null}))
             }
         }else {
             combinedActions[action](payload)
         }
    }

    debouncedEmit(event, data, interval = 150) {
        if (!this.socket) return;
            this.socket.emit(event, data);
    }
}
const UserSocket = new UserSockets()
export default UserSocket ;
